<template>
  <Calendar locale="nl" :min-date="getMinDate" :max-date="getMaxDate" :attributes="attrs" :from-page="getFromPageDate" />
</template>

<script>
import { Calendar, DatePicker } from 'v-calendar';

export default {
  props: [
    'translations',
    'jsonDates',
    'jsonYears',
    'fromPageDate',
  ],
  components: {
    Calendar,
    DatePicker,
  },
  data() {
    return {
      dates: JSON.parse(this.jsonDates),
      years: Object.values(JSON.parse(this.jsonYears)),
      attrs: [],
    };
  },
  mounted() {
    this.attrs = this.dates.map((date) =>{
      return {
        highlight: {
          class: date.class,
          contentClass: date.class,
          fillMode: 'solid',
        },
        dates: new Date(date.year, date.month - 1, date.day)
      }
    })
  },
  computed: {
    getMaxDate() {
      return new Date(Math.max(...this.years),11, 31);
    },
    getMinDate() {
      if (!this.fromPageDate) {
        const today = new Date();

        return new Date(today.getFullYear(), today.getMonth(), 1);
      }

      const dateInDashFormat = new Date(this.fromPageDate.split('/').reverse().join('-'));

      return new Date(dateInDashFormat.getFullYear(), dateInDashFormat.getMonth(), 1);
    },
    getFromPageDate() {
      if (!this.fromPageDate) {
          return null;
      }

      const dateParts = this.fromPageDate.split("/");

      return {
        month: parseInt(dateParts[1]),
        year: parseInt(dateParts[2]),
      }
    },
  },
};
</script>

<style>
.center {
  text-align: center;
}
</style>
